import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const RushFeeModal = ({ isOpen, onClose, onUpdate, initial = {}, loadLanguages }) => {
  const [languageId, setLanguageId] = useState(initial.languageId || '');
  const [languageLabel, setLanguageLabel] = useState(initial.languageLabel || '');
  const [rushFee, setRushFee] = useState(initial.rush_fee ?? '');

  useEffect(() => {
    setLanguageId(initial.languageId || '');
    setLanguageLabel(initial.languageLabel || '');
    setRushFee(initial.rush_fee ?? '');
  }, [initial, isOpen]);

  const handleUpdate = () => {
    if (!languageId || rushFee === '') return;
    onUpdate({ languageId, languageLabel, rush_fee: rushFee });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <div className="modal-header" style={{ padding: 30, border: 'none' }}>
        <h5 className="modal-title_u">Edit Rush Fee</h5>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>
      <div className="modal-body" style={{ padding: 30, paddingBottom: 0 }}>
        <div className="mb-3">
          <div className="row-primary m-0">
            <h2 style={{ minWidth: 80 }}>Language</h2>
            <div style={{ width: '100%' }}>
              <AsyncPaginate
                menuPlacement="auto"
                styles={{ ...selectCustomStyles }}
                value={languageId ? { value: languageId, label: languageLabel } : null}
                loadOptions={loadLanguages}
                isClearable
                escapeClearsValue
                onChange={(selected) => {
                  const sel = Array.isArray(selected) ? selected[0] : selected;
                  setLanguageId(sel?.value || '');
                  setLanguageLabel(sel?.label || '');
                }}
                additional={{ page: 1 }}
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="row-primary m-0">
            <h2 style={{ minWidth: 80 }}>Rush Fee</h2>
            <input
              type="number"
              className="input-in type_inp"
              placeholder="Rush Fee"
              value={rushFee}
              onChange={(e) => setRushFee(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer" style={{ padding: 30, border: 'none' }}>
        <button className="Cancle_button" onClick={onClose}>Cancel</button>
        <button className="main_button" onClick={handleUpdate}>Update</button>
      </div>
    </Modal>
  );
};

export default RushFeeModal;
